import { GetRegion } from 'constants.js';
import { getApaMetadata, getApaAssets } from 'services/api/microfwk';
import _ from 'lodash';

export const getApaMetadataLite = () => {
  const getAppKey = region => `d48c48c956cda082e2e03b717c81c220-${region}`;
  return getApaMetadata({
    sessionKey: getAppKey(GetRegion()),
  })
    .then(({ translations }) => JSON.parse(translations).language[GetRegion()])
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
};

const getPlanSelectAppKey = (productType, region) =>
  `SelectorDePlan_Tarjeta_${productType}-${region}`;

export const getApaTranslationsWithAppKey = productType => {
  return getApaMetadata({
    sessionKey: getPlanSelectAppKey(productType, GetRegion()),
  })
    .then(({ translations }) => JSON.parse(translations).language[GetRegion()])
    .catch(() => ({}));
};

export const getApaAssetWithAppKey = productType => {
  return getApaAssets({
    sessionKey: getPlanSelectAppKey(productType, GetRegion()),
  })
    .then(assets => {
      return assets;
      // return assets.language[GetRegion()];
    })
    .catch(() => ({}));
};
